import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';


const complianceItems = [
  { label: 'Fire Safety Compliance', pct: 94, status: 'green', overdue: 1, upcoming: 2 },
  { label: 'Environmental Permits', pct: 78, status: 'amber', overdue: 3, upcoming: 5 },
  { label: 'Pressure Vessel Certs', pct: 88, status: 'green', overdue: 0, upcoming: 3 },
  { label: 'Electrical Safety', pct: 62, status: 'red', overdue: 6, upcoming: 4 },
];

const trainingDonut = [
  { name: 'Mandatory Trained', value: 82, color: '#10b981' },
  { name: 'Mandatory Pending', value: 18, color: '#ef4444' },
];

const skillDonut = [
  { name: 'Skill Trained', value: 67, color: '#3b82f6' },
  { name: 'Skill Pending', value: 33, color: '#94a3b8' },
];

const expiryItems = [
  { label: 'First Aid Cert — J. Patel', days: 3, rag: 'red' },
  { label: 'Confined Space — R. Kumar', days: 8, rag: 'red' },
  { label: 'HAZMAT Handling — S. Lee', days: 14, rag: 'amber' },
  { label: 'Fire Warden — A. Singh', days: 21, rag: 'amber' },
  { label: 'Scaffold Inspection — M. Ali', days: 30, rag: 'green' },
];

const ragBar = { green: 'bg-emerald-500', amber: 'bg-amber-500', red: 'bg-red-500' };
const ragText = { green: 'text-emerald-400', amber: 'text-amber-400', red: 'text-red-400' };
const ragBg = { green: 'bg-emerald-500/10', amber: 'bg-amber-500/10', red: 'bg-red-500/10' };

const ComplianceTrainingSection = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-1 h-6 bg-violet-500 rounded-full" />
        <h2 className="text-base font-semibold text-foreground">Compliance & Training</h2>
        <span className="ml-auto text-xs text-muted-foreground bg-muted px-2 py-1 rounded-full">Current Period</span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Progress Bars */}
        <div>
          <p className="text-xs font-medium text-muted-foreground mb-3 uppercase tracking-wide">Statutory Compliance %</p>
          <div className="space-y-4">
            {complianceItems?.map((item) => (
              <div key={item?.label}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs font-medium text-foreground">{item?.label}</span>
                  <span className={`text-xs font-bold ${ragText?.[item?.status]}`}>{item?.pct}%</span>
                </div>
                <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full ${ragBar?.[item?.status]}`}
                    style={{ width: `${item?.pct}%`, transition: 'width 0.6s ease' }}
                  />
                </div>
                <div className="flex gap-3 mt-1">
                  <span className="text-xs text-red-400">{item?.overdue} overdue</span>
                  <span className="text-xs text-amber-400">{item?.upcoming} upcoming</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Donut + Expiry */}
        <div className="space-y-4">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">Training Coverage</p>
          <div className="flex items-center gap-4">
            <div className="flex flex-col items-center">
              <ResponsiveContainer width={90} height={90}>
                <PieChart>
                  <Pie data={trainingDonut} cx="50%" cy="50%" innerRadius={28} outerRadius={42} dataKey="value" startAngle={90} endAngle={-270}>
                    {trainingDonut?.map((e, i) => <Cell key={i} fill={e?.color} />)}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <p className="text-xs text-muted-foreground text-center mt-1">Mandatory</p>
              <p className="text-sm font-bold text-foreground">82%</p>
            </div>
            <div className="flex flex-col items-center">
              <ResponsiveContainer width={90} height={90}>
                <PieChart>
                  <Pie data={skillDonut} cx="50%" cy="50%" innerRadius={28} outerRadius={42} dataKey="value" startAngle={90} endAngle={-270}>
                    {skillDonut?.map((e, i) => <Cell key={i} fill={e?.color} />)}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <p className="text-xs text-muted-foreground text-center mt-1">Skill-Based</p>
              <p className="text-sm font-bold text-foreground">67%</p>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-muted-foreground mb-2 uppercase tracking-wide">Cert Expiry Alerts</p>
              <div className="space-y-1.5">
                {expiryItems?.map((item) => (
                  <div key={item?.label} className={`flex items-center justify-between px-2 py-1.5 rounded-lg ${ragBg?.[item?.rag]}`}>
                    <span className="text-xs text-foreground truncate flex-1 pr-2">{item?.label}</span>
                    <span className={`text-xs font-bold flex-shrink-0 ${ragText?.[item?.rag]}`}>{item?.days}d</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplianceTrainingSection;